<template>
  <div>
    <ValidationObserver ref="observer">
      <ValidationProvider
        rules="required"
        v-slot="{ errors }"
        name="office Type"
      >
        <eb-select
          type="text"
          v-model="office.officeType"
          :options="officeOptions"
          label="label"
          placeholder="Select Office Type * "
        ></eb-select>
        <span class="validate-error" style="color: red">{{ errors[0] }}</span>
      </ValidationProvider>
      <slot name="name" :data="office.officeName">
        <ValidationProvider
          rules="required"
          v-slot="{ errors }"
          name="office Name"
        >
          <c-input
            inputType="text"
            inputId="userName"
            lableText="Office Name *"
            v-model="office.officeName"
            class="mt-3"
          />
          <span class="validate-error" style="color: red">{{ errors[0] }}</span>
        </ValidationProvider>
      </slot>
      <b-row class="mt-2" v-for="(p, idx) in office.phone" :key="p + `${idx}`">
        <b-col md="9" class="pr-0">
          <ValidationProvider
            rules="required|min:15|max:15"
            v-slot="{ errors }"
            name="phone number "
          >
            <c-tel-input
              v-model="p.number"
              @validate="(e) => isValidate(e, p)"
              class="m-0"
            />
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md="3" class="pl-0">
          <b-button
            btn-special="primary"
            size="lg"
            class="add-new-btn"
            @click="onClickPhoneButton(p, idx)"
          >
            <i class="fa fa-plus-circle"></i>
            {{ p.text }}
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-for="(e, idx) in office.email" :key="idx" required>
        <b-col md="9" class="pr-0">
          <ValidationProvider
            rules="required|email|"
            v-slot="{ errors }"
            name="email"
            v-if="!setvalues"
          >
            <c-input
              inputType="text"
              inputId="email"
              lableText="Email *"
              v-model="e.mailId"
            />
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md="3" class="pl-0">
          <b-button
            btn-special="primary"
            class="add-new-btn"
            size="lg"
            @click="onClickEamilButton(e, idx)"
          >
            <i class="fa fa-plus-circle"></i>
            {{ e.text }}
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <div class="form-group">
            <ValidationProvider
              rules="required"
              v-slot="{ errors, validate }"
              name="Location"
            >
              <GmapAutocomplete
                @place_changed="placechange1"
                @change="validate"
                class="form-control location-search"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
              ></GmapAutocomplete>
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </b-col>
      </b-row>
      <div>
        <b-row>
          <b-col md="12">
            <c-input
              type="text"
              inputId="state"
              readonly
              v-model="office.address.country"
              lableText="Country"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <c-input
              type="text"
              inputId="state"
              readonly
              v-model="office.address.state"
              lableText="State"
            />
          </b-col>

          <b-col md="6">
            <c-input
              type="text"
              inputId="city"
              readonly
              v-model="office.address.city"
              lableText="City"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <ValidationProvider
              rules="required|min:6|max:6|"
              v-slot="{ errors }"
              name="zipcode"
            >
              <c-input
                inputType="number"
                inputId="zipcode"
                v-model="office.address.zip"
                lableText="Zipcode"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>

        <br />
        <br />
        <slot name="footer-button" :data="office">
          <b-button
            class="btn btn-block mt-3"
            btn-color="primary"
            @click="(e) => $emit('onClickOffice', office)"
            >Next</b-button
          >
        </slot>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import locationMixins from "@/mixins/addressLocation";

export default {
  name: "OfficeStepper",
  mixins: [locationMixins],
  data() {
    return {
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      setvalues: false,
      office: {
        officeType: null,
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
          },
        ],

        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null,
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
            isValid: false,
          },
        ],
        address: {
          country: "",
          area: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
    };
  },
  props: {
    tenants: Array,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    cInput,
    cTelInput,
    ebSelect,
  },
  computed: {
    tenantOptions() {
      return this.tenants
        ? this.tenants.map((t) => ({
            label: t.authentication.userName,
            value: t._id,
          }))
        : [];
    },
    officeOptions() {
      return [
        {
          label: "Default",
          value: "DEFAULT",
        },
        {
          label: "Head Office",
          value: "HEAD_OFFICE",
        },
        {
          label: "Regional Office",
          value: "REGIONAL_OFFICE",
        },
        {
          label: "Branch Office",
          value: "BRANCH_OFFICE",
        },
      ];
    },
  },
  methods: {
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
    placechange1(e) {
      this.placechange(e);
      this.$emit("place_changed", e);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapdata) {
        this.office.address.country = mapdata.data.Country;
        this.office.address.city = mapdata.data.City;
        this.office.address.state = mapdata.data.State;
        this.office.address.area = mapdata.data.Area ? mapdata.data.Area : "";
        this.office.address.zip = mapdata.data.zip ? mapdata.data.zip : "";
        this.office.address.location = {
          coordinates: [mapdata.Lng, mapdata.Lat],
        };
      }
    },
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.office.email.splice(idx, 1);
    },
    async onClickPhoneButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null,
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.office.phone.splice(idx, 1);
    },
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  width: 132px;
  background-color: var(--primary);
  color: white;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}

.add-new-btn{
  width: 100% !important;
  display: inline-block;
  font-size: 12px !important;
  padding: 10px 14px;
}
.add-new-btn i{
  margin-right: 5px;
}
</style>
